// supabaseClient.js
import { createClient } from "@supabase/supabase-js";

export const supabaseUrl = "https://kbuzjqfgjvrgbivzbxjb.supabase.co";
export const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtidXpqcWZnanZyZ2JpdnpieGpiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTAxMzkxMTQsImV4cCI6MjAyNTcxNTExNH0.3TWBggksTLbCjzG0T8DViNZ9RTYAUWQMnHhNoaPuy6Q";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
